import { Component, OnInit, Input, forwardRef, Injector, OnChanges, SimpleChange} from '@angular/core';
import { NgControl, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpService } from 'src/app/core/http/http.service';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';


@Component({
  selector: 'mat-select-search',
  templateUrl: './mat-select-search.component.html',
  providers: [
    { 
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MatSelectSearchComponent),
    }
  ]
})
export class MatSelectSearchComponent implements OnInit, ControlValueAccessor, OnChanges  {
    
  @Input() placeholder :  string = 'Procurar';
  @Input() endpoint:  any = null;
  @Input() classTag:  string = '';
  @Input() idField:  string = '';
  @Input() textField:  string = '';
  @Input() formDisabled:  boolean = false;

  private initialSetValue = true;

  items: any[] = [];

  ngControl: NgControl;

  
  public selectServerControl: FormControl = new FormControl();

  public selectControl: FormControl = new FormControl();
  
  public searching: boolean = false;

  constructor(private httpService: HttpService, private inj: Injector) {
  }



  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (changes.hasOwnProperty('formDisabled')) {
      this.toogleDisabled(changes.formDisabled.currentValue);
    }
  }

  toogleDisabled(disabled){
    if(disabled){
      this.selectControl.disable();
      this.selectServerControl.disable();
    } else {
      this.selectControl.enable();
      this.selectServerControl.enable();
    }
  }


  change(event){
    if(event.isUserInput){
      this.value = event.source.value;
    } 
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if(value == null)
      return false;

    
    if(value[this.idField] !== undefined){
      this.items = [value];
      this.selectControl.setValue(value[this.idField]);
      
      return false;
    }
    
    this.selectControl.setValue(value);
    this.innerValue = value;
    this.search(null,value);
  }

  ngOnInit() {

    this.ngControl = this.inj.get(NgControl);

    this.selectServerControl.valueChanges
      .pipe(
        filter(text => typeof text =='string' &&  text.length > 1),
        debounceTime(250),
        distinctUntilChanged()
      )
      .subscribe((value: any) => {
          this.search(value);
      });

      this.selectControl.updateValueAndValidity();

    this.toogleDisabled(this.formDisabled);
  }

  search(text, id = false){

    if(id == null)
      return;


    this.searching = true;

    this.httpService
      .post(this.endpoint,id?  {"type":"owner", "search":["AND", ["LIKE", ["column", this.idField, "p"], id]]} : 
                               {"type":"owner", "search":["AND", ["LIKE", ["column", "name", "p"], text+"%"]], "sort_column":"name", "sort_direction":"ASC"})
      .then(result => {
        this.searching = false;
        this.items = result['list'];
      })
      .catch( error => {
        this.searching = false;
      });
  }

  //The internal data model
  private innerValue: any = '';

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void =() => {};

  //get accessor
  get value(): any {
      return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
      if (v !== this.innerValue) {
          this.innerValue = v;

          this.ngControl.control.setValue(v);
          
          if(!this.initialSetValue)
            this.onChangeCallback(v);
          else
            this.initialSetValue = false;
      }
  }

  //Set touched on blur
  onBlur() {
      //this.onTouchedCallback();
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
      this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
      this.onTouchedCallback = fn;
  }

  typeof(value){
    return typeof value;
  }

  objectFilter(items: any[], key : any,  value: any, contain: boolean = true, textContain:boolean = false): any {

    if (!items || !value || !items?.length) {
        return [];
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items?.filter(item => {
        /*if(typeof key === 'object' && typeof value === 'object'){
            let has = 0;
            
            value.forEach((v, k) => {
                console.log(v, key[k], k, item[key[k]]);
                if(item[key[k]] == v)
                    has++;
            });
            console.log(has);
            return contain? has == value.length : has != value.length;
        }*/

        let i = typeof key === 'object'? item : item[key];
        if(typeof key === 'object')
            key.map(k => {
                if(typeof i[k] !== 'undefined')
                    i = i[k];
            } );

        let has = (i == value || (typeof value ==='object' && value.indexOf(i) > -1) || (typeof i === 'object' && i.indexOf(value) !== -1) || (typeof i === 'string' && i == value && !textContain) || (typeof i === 'string' && i.indexOf(value) > -1 && textContain));

        return contain? has : !has;
    });
  }


}